import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('token'),  // Initialize from localStorage
  coachId: localStorage.getItem('coachId'),  // Initialize from localStorage
  login: (token, coachId) => {
    localStorage.setItem('token', token); // Save to localStorage
    localStorage.setItem('coachId', coachId); // Save to localStorage
    set({ token, coachId });
  },
  logout: () => {
    localStorage.removeItem('token');  // Clear from localStorage
    localStorage.removeItem('coachId'); // Clear from localStorage
    set({ token: null, coachId: null });
  },
}));
